"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshTokenGuard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useRefreshToken_1 = require("../hooks/useRefreshToken");
const Date_1 = require("../../Date");
const useAuthProces_1 = require("../hooks/useAuthProces");
const react_ui_1 = require("@pasport/react-ui");
const hooks_1 = require("../hooks");
const Config_1 = require("../../Config");
const RefreshTokenGuard = ({ children }) => {
    const { refreshToken, triggerRefreshTokens, accessTokenExpirationAt, } = (0, useRefreshToken_1.useRefreshToken)();
    const [refreshCount, setRefreshCount] = (0, react_1.useState)(0);
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const { authTokens } = (0, hooks_1.useAuthTokens)();
    const happyRef = (0, react_1.useRef)(true);
    const { loadAuthInfo } = (0, useAuthProces_1.useAuthProcess)();
    //initial refresh
    (0, react_1.useEffect)(() => {
        if (refreshCount === 0 && refreshToken && happyRef.current) {
            happyRef.current = false;
            triggerRefreshTokens().then((response) => {
                if (response)
                    setRefreshCount(value => value + 1);
            });
        }
    }, [refreshCount, refreshToken]);
    (0, react_1.useEffect)(() => {
        if (authTokens?.accessToken && refreshCount > 0) {
            loadAuthInfo();
        }
    }, [authTokens?.accessToken, refreshCount]);
    (0, react_1.useEffect)(() => {
        const timeoutId = setTimeout(() => {
            setIsReady(true);
        }, 0);
        return () => clearTimeout(timeoutId);
    }, []);
    //refresh before expiration
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            if (!accessTokenExpirationAt)
                return;
            const expiresWithinSeconds = (0, Date_1.getDifferenceInSeconds)(new Date(), accessTokenExpirationAt);
            if (accessTokenExpirationAt && expiresWithinSeconds < (0, Config_1.getConfigValue)('AUTH_TIMEOUT_REFRESH_BEFORE_EXPIRATION') / 1000) {
                triggerRefreshTokens();
            }
        }, 2000);
        return () => clearInterval(intervalId);
    }, [accessTokenExpirationAt]);
    if (!isReady)
        return (0, jsx_runtime_1.jsx)("div", { children: "waiting" });
    if (!refreshToken || refreshCount > 0) { //if not logged in or if already access token is refreshed
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    else {
        return (0, jsx_runtime_1.jsx)(react_ui_1.CenterView, { children: "..." });
    }
};
exports.RefreshTokenGuard = RefreshTokenGuard;
